export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 球队列表
    getTeamsAllList: function getTeamsAllList(data) {
      return request({
        url: '/atmolab/getTeamsAllList',
        method: 'get',
        data: data
      });
    },
    addTeams: function addTeams(data) {
      return request({
        url: '/atmolab/addTeams',
        method: 'post',
        data: data
      });
    },
    updateTeams: function updateTeams(data) {
      return request({
        url: '/atmolab/updateTeams',
        method: 'post',
        data: data
      });
    },
    delTeams: function delTeams(data) {
      return request({
        url: '/atmolab/delTeams',
        method: 'post',
        data: data
      });
    },
    //年龄组列表
    ageGroupList: function ageGroupList(data) {
      return request({
        url: '/config/ageGroupList',
        method: 'get',
        data: data
      });
    },
    venuesList: function venuesList(data) {
      return request({
        url: '/venues/list',
        method: 'get',
        data: data
      });
    },
    delVenues: function delVenues(data) {
      return request({
        url: '/venues/delVenues',
        method: 'post',
        data: data
      });
    },
    updateVenues: function updateVenues(data) {
      return request({
        url: '/venues/updateVenues',
        method: 'post',
        data: data
      });
    },
    addVenues: function addVenues(data) {
      return request({
        url: '/venues/addVenues',
        method: 'post',
        data: data
      });
    },
    unboundCoachesList: function unboundCoachesList(data) {
      return request({
        url: '/atmolab/unboundCoachesList',
        method: 'post',
        data: data
      });
    },
    bindTeamByCoach: function bindTeamByCoach(data) {
      return request({
        url: '/atmolab/bindTeamByCoach',
        method: 'post',
        data: data
      });
    },
    teamByCoachesList: function teamByCoachesList(data) {
      return request({
        url: '/atmolab/teamByCoachesList',
        method: 'get',
        data: data
      });
    },
    getStudentsAll: function getStudentsAll(data) {
      return request({
        url: '/atmolab/getStudentsAll',
        method: 'get',
        data: data
      });
    },
    auditStudent: function auditStudent(data) {
      return request({
        url: '/atmolab/auditStudent',
        method: 'post',
        data: data
      });
    },
    getParentsAll: function getParentsAll(data) {
      return request({
        url: '/atmolab/getParentsAll',
        method: 'get',
        data: data
      });
    }
  };
});